import React from 'react';

// Keeps one failing page from blanking the whole admin shell
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Page crashed:', error, info);
  }

  componentDidUpdate(prevProps) {
    // Reset when navigating to another page
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="card p-10 text-center max-w-md mx-auto mt-16">
        <p className="text-gray-900 font-medium">Something went wrong on this page</p>
        <p className="text-sm text-gray-500 mt-1">Try reloading. If it keeps happening, the data from the server may be incomplete.</p>
        <button
          onClick={() => window.location.reload()}
          className="mt-5 px-5 py-2.5 bg-brand-600 text-white text-sm font-medium rounded-full hover:bg-brand-700"
        >
          Reload
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
